import { Accordion } from "react-bootstrap";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { emotionToFields } from "../helpers/reportHelpers";
import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext";

const emotionThresholds = {
	Anger: [15, 80],
	Anxiety: [15, 80],
	Fear: [15, 80],
	Joy: [20, 80],
	Love: [20, 80],
	Sadness: [15, 80],
	Shame: [15, 80],
};

const EmotionAccess = ({ emotion }) => {

	const { respondent } = useUser();
	const { reportContent: { acf: { emotions } } } = useReport();
	const percentile = respondent?.weqProfile?.percentiles?.[`${emotionToFields[emotion]}_dist`];

	const shouldRenderSection = useMemo(() => emotion === 'Joy'
		? respondent?.weqProfile?.percentiles.love_Joy_Combined >= 60 && percentile - respondent?.weqProfile?.percentiles.fLO_dist <= 12
		: emotion === 'Love'
			? percentile <= emotionThresholds[emotion][0]
			: percentile <= emotionThresholds[emotion][0] || percentile >= emotionThresholds[emotion][1], [percentile, emotion]);

	const titleContent = useMemo(() => percentile <= emotionThresholds[emotion][0]
		? emotions[emotion.toLowerCase()].limited
		: percentile >= emotionThresholds[emotion][0]
			? emotions[emotion.toLowerCase()].high
			: null, [percentile, emotion, emotions]);

	return shouldRenderSection
		? (
			<Accordion className="plain emotions-access" defaultActiveKey={emotion}>
				<Accordion.Item eventKey={emotion}>
					<Accordion.Header>
						{titleContent.title}
					</Accordion.Header>
					<Accordion.Body>
						<div className={`assessment-text ${percentile <= emotionThresholds[emotion][0] ? 'rating-0' : 'rating-5'}`} dangerouslySetInnerHTML={{ __html: titleContent.content }} />
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>
		)
		: null;
};

EmotionAccess.propTypes = {
	emotion: PropTypes.oneOf(Object.keys(emotionThresholds)).isRequired,
};

export default EmotionAccess;
